import React, { memo, useContext } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { CTA } from '../../interfaces/CTA.interface';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import ProgressBar from './ProgressBar';
import FormFieldTextInput from '../FormFields/FormFieldTextInput/FormFieldTextInput';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import SbImage from '../SbImage/SbImage';
import { QuickQuoteContext, Service } from '../../contexts/QuickQuote.context';
import { useFormikContext } from 'formik';

interface QuickQuoteCardBtnProps {
  name: string;
  option: string;
  service: Service;
  label: string;
  description: string;
  icon: StoryblokAsset;
}

const QuickQuoteCardBtn: React.FC<QuickQuoteCardBtnProps> = ({
  name,
  option,
  service,
  label,
  description,
  icon,
}) => {
  const { setService, setQuoteStep, quoteStep } = useContext(QuickQuoteContext);
  const { setFieldValue } = useFormikContext();

  return (
    <button
      className="bg-system/white w-full hover:cursor-pointer rounded-[8px] shadow-sm hover:border-[#009bef] border border-system/white transition-all h-full"
      onClick={() => {
        setFieldValue(name, option);
        service && setService(service); // Set the service to the name passed as prop
        setQuoteStep(quoteStep + 1); // You can change the step number as needed
      }}
      type="button"
    >
      <div className="flex p-3 h-full">
        <div className="flex-shrink-0 pt-[2px]">
          <SbImage
            asset={icon}
            options={{
              objectFit: 'contain',
              width: 17,
              height: 17,
              sizes: { base: 17 },
            }}
          />
        </div>
        <div className="ml-4 pr-6">
          <p className="text-left font-bold">{label}</p>
          {description && <p className="text-left text-sm">{description}</p>}
        </div>
        <div className="ml-auto flex items-center">
          <div
            className="bg-no-repeat scale-[0.9] min-w-[1.5em] min-h-[1.5em] w-[1.5em] h-[1.5em] bg-text/body-disabled"
            style={{
              WebkitMaskImage: "url('/svgs/right-arrow.svg')",
              maskImage: "url('/svgs/right-arrow.svg')",
            }}
          />
        </div>
      </div>
    </button>
  );
};

export default withBlokWrapper(QuickQuoteCardBtn, Theme.ALT);
